import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NewExistingRadio } from '@zocdoc/components/src/newexistingradio';
import { selectPatientStatus } from '@zocdoc/components/src/newexistingradio/NewExistingRadioActions';
import { trackNewExistingToggleView } from '../../actions/eventTracking';
import { mapStateToProps } from './mapStateToProps';

const mapDispatchToProps = {
    selectPatientStatus,
    trackNewExistingToggleView,
};

// HOC to track a view (onMount) on this component
function withViewTracking(WrappedComponent) {
    return class BookingSectionNewExistingRadio extends React.Component {
        static propTypes = {
            trackNewExistingToggleView: PropTypes.func,
        }

        static defaultProps = {
            trackNewExistingToggleView: noop,
        }

        componentDidMount() {
            this.props.trackNewExistingToggleView();
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withViewTracking(NewExistingRadio));
